import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-secondary-button.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-secondary-button.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { AflaCommonService } from "../../afla-common.service";
let CommonSecondaryButtonComponent = class CommonSecondaryButtonComponent {
    aflaCommonService;
    displayText = "";
    clickCallBack = new EventEmitter();
    disabled = false;
    branding;
    constructor(aflaCommonService) {
        this.aflaCommonService = aflaCommonService;
        this.branding = aflaCommonService.branding;
    }
    ngOnInit() {
        this.displayText = this.displayText.toLowerCase();
    }
    onclick($event) {
        this.clickCallBack.emit($event);
    }
    static ctorParameters = () => [
        { type: AflaCommonService }
    ];
    static propDecorators = {
        displayText: [{ type: Input }],
        clickCallBack: [{ type: Output }],
        disabled: [{ type: Input }]
    };
};
CommonSecondaryButtonComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: "lib-secondary-button[displayText]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonSecondaryButtonComponent);
export { CommonSecondaryButtonComponent };
